var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzureDataFactory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGSXZNQdYI",
    x1: 282.243,
    x2: 641.667,
    y1: 254.043,
    y2: 254.043,
    gradientTransform: "translate(-15.58 286.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#095ca2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#0b61aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2170b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2974ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2471b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#176ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#095ca2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#095ca2",
    d: "M95.996 75.12V45.687a1.03 1.03 0 0 0-1.033-1.069c-.285 0-.57.107-.766.32L64.071 75.049l-31.319 31.319v21.615H123.7c2.333.036 4.255-1.816 4.291-4.13V45.687a1.03 1.03 0 0 0-1.033-1.069c-.284 0-.57.107-.765.32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGSXZNQdYI)",
    d: "M446.4 279.6c-99.4 0-179.7-29.2-179.7-66.8v631.4c-.2 13.1 10.2 23.9 23.2 24.1h336.2V212.8c0 37.6-80.4 66.8-179.7 66.8",
    transform: "translate(-47.477 -26.6)scale(.17805)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M95.55 93.868h12.873c1.158 0 2.101.944 2.101 2.1v12.874a2.105 2.105 0 0 1-2.1 2.1H95.55a2.105 2.105 0 0 1-2.1-2.1V95.969c-.018-1.157.925-2.101 2.1-2.101m-29.663 0H78.76c1.158 0 2.101.944 2.101 2.1v12.874a2.105 2.105 0 0 1-2.1 2.1H65.886a2.105 2.105 0 0 1-2.1-2.1V95.969c-.018-1.157.925-2.101 2.1-2.101zm-29.663 0h12.873c1.158 0 2.101.944 2.101 2.1v12.874a2.105 2.105 0 0 1-2.1 2.1H36.223a2.105 2.105 0 0 1-2.1-2.1V95.969c-.019-1.157.925-2.101 2.1-2.101z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M64 11.288C64 17.68 49.703 22.88 32.004 22.88S.01 17.983.01 11.29C.009 4.593 14.306 0 32.004 0C49.703 0 64 5.181 64 11.288"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#76cae7",
    d: "M56.468 10.612c0 4.148-10.985 7.531-24.535 7.531S7.38 14.903 7.38 10.612s11.449-7.3 24.624-7.3c13.176 0 24.464 3.222 24.464 7.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c8bb4",
    d: "M32.004 12.339a61.4 61.4 0 0 0-19.425 2.777a57.6 57.6 0 0 0 19.425 2.867a57.6 57.6 0 0 0 19.426-2.867a61 61 0 0 0-19.426-2.777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureDataFactory);
export default __webpack_public_path__ + "static/media/azure-data-factory.5a3d8941b429437dcbb0e76ff3a559c9.svg";
export { ForwardRef as ReactComponent };